import $ from 'jquery';
import _ from 'lodash';
import { onAddImageToCanvas } from '~src/image';
import { getState } from '~src/state';
import { EdgeResizer } from '~src/utils';
import {
  getUser,
  isLoggedUserGlobalEditor,
  isLoggedUserSuperUser,
} from '~src/user';
import { onAddMagicFrameToCanvas } from '~core/magicFrame';
import editorConfig from '~config/editorConfig';
import differenceInDays from 'date-fns/differenceInDays';

const hasTagMagicFrame = (tags = []) =>
  tags.some((tag) => tag.name === editorConfig.magicFrameTag);

const htmlImages = async (sidebarImages) => {
  const { user } = await getUser();
  const [isGlobalEditor, isSuperUser] = await Promise.all([
    isLoggedUserGlobalEditor(),
    isLoggedUserSuperUser(),
  ]);
  const isGlobalPrivileged = isGlobalEditor || isSuperUser;

  const { items, html } = sidebarImages.reduce(
    (acc, item) => {
      let previewImg = new EdgeResizer(item.file.url).scaleToWidth(160);
      if (item.custom_preview) {
        previewImg = new EdgeResizer(item.custom_preview.url).scaleToWidth(160);
      } else {
        previewImg = new EdgeResizer(item.file.url).scaleToWidth(160);
      }

      const itemId = `editor-sidebar-add-canvas-image-${item.objectId}`;

      const isUserOwner =
        user.org_pointer.objectId === item.org_pointer?.objectId;
      const canDeleteImage = isUserOwner || isGlobalPrivileged;

      // Tutte le immagini espongono le azioni nel menu a 3 puntini in alto
      // a destra (pattern Foto allegate): Info sempre, Elimina quando consentito.
      let buttons = `<div class="option-button-container bg-color-attachments">
                      <div class="option-button-container-relative">
                        <div class="context-menu context-menu-child bg-color-attachments color-existing-canvas">
                          <div
                            class="item context-menu-child"
                            data-images-item-id="${item.objectId}"
                            data-tab-target="tab-images-tag">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Info
                          </div>`;

      if (canDeleteImage) {
        buttons += `
                          <div
                            class="item context-menu-child"
                            data-delete-images-id="${item.objectId}"
                            data-delete-images-is-global="${
                              item.isGlobal === true
                            }">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3m-8 0h10" />
                            </svg>
                            Elimina
                          </div>`;
      }

      buttons += `
                        </div>
                      </div>
                    </div>`;

      acc.html += '<div class="sidebar-item-grid-box image-square-container">';

      if (
        differenceInDays(new Date(), new Date(item.createdAt)) <= 30 &&
        item.isGlobal === true
      ) {
        acc.html += '<div class="sidebar-badge-new">Novità</div>';
      }

      acc.html += `<div id="${itemId}" data-url="${
        item.file.url
      }" data-width="${item.width}" data-height="${
        item.height
      }" data-svg-clip="${_.get(
        item,
        'svgClip.url',
        ''
      )}" class="sidebar-item-grid-box-click-listener"></div>
                          <img
                              src="../assets/svg/img-loader.gif"
                              class="lazy image-square"
                              data-src="${previewImg}"
                              data-canvas-drag-source="true"
                          />
                      ${buttons}
                    </div>`;

      const element = {
        id: `#${itemId}`,
      };

      if (hasTagMagicFrame(item.tags)) {
        element.type = 'magic-frame';
      } else {
        element.type = 'image';
      }

      acc.items.push(element);

      return acc;
    },
    { items: [], html: '' }
  );

  if (items.length) {
    items.forEach((item) => {
      $('body').off(
        'click',
        item.id,
        item.type === 'magic-frame'
          ? onAddMagicFrameToCanvas
          : onAddImageToCanvas
      );
      $('body').on(
        'click',
        item.id,
        item.type === 'magic-frame'
          ? onAddMagicFrameToCanvas
          : onAddImageToCanvas
      );
    });
  }
  return html;
};

const templateAddImagesDefault = async (images) => {
  const imagesDefault = images.filter((images) => images.isGlobal === true);

  let html;

  if (imagesDefault.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono sfondi disponibili</div></div>';
  } else {
    html = await htmlImages(imagesDefault);
  }

  $('#editor-sidebar-images').html(html);
};

const templateAddImagessCustom = async (images) => {
  const { user } = await getUser();

  const imagesCustom = images.filter(
    (images) =>
      images.org_pointer &&
      images.org_pointer.objectId === user.org_pointer.objectId
  );

  let html;

  if (imagesCustom.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non hai caricato immagini personalizzate</div></div>';
  } else {
    html = await htmlImages(imagesCustom);
  }

  $('#editor-sidebar-images-custom').html(html);
};

export const displaySidebarImages = async () => {
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');

  const sidebarImages = _.get(
    window.editorConfig,
    `sidebarImages[${currentTag}]`,
    { items: [] }
  );

  await Promise.all([
    templateAddImagesDefault(sidebarImages.items),
    templateAddImagessCustom(sidebarImages.items),
  ]);

  window.lazyLoadInstance.update();
};
